import type { PaneKind } from '../../shared/contracts';

/** How many grid columns a pane spans (lists, agendas and big charts are wider). */
export function paneSpan(pane: { id: string; kind: PaneKind }): number {
  if (pane.kind === 'list' || pane.kind === 'ranking' || pane.kind === 'agenda') return 2;
  // Monthly bar/area charts squeezed into one column look starved — give them half a row.
  if (pane.id === 'marketing.sessions' || pane.id === 'admin.forecast' || pane.id === 'marketing.subscribers') return 2;
  if (pane.id === 'marketing.sql' || pane.id === 'marketing.trials' || pane.id === 'support.portalLoginsMonthly') return 2;
  // Nine-country legend beside the pie needs the width of half a row.
  if (pane.id === 'marketing.sessionsCountry') return 2;
  return 1;
}

export function spanClass(span: number): string {
  return span >= 2 ? 'sm:col-span-2' : '';
}
